var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33,14H30V10a6,6,0,0,0-12,0v4H15a1,1,0,0,0-1,1V27a1,1,0,0,0,1,1H33a1,1,0,0,0,1-1V15A1,1,0,0,0,33,14ZM20,10a4,4,0,0,1,8,0v4H20ZM32,26H16V16H32Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.707,32.293a.9994.9994,0,0,0-1.414,0L9,33.5859,7.707,32.293a1,1,0,0,0-1.414,1.414L7.5859,35,6.293,36.293a1,1,0,1,0,1.414,1.414L9,36.4141l1.293,1.2929a1,1,0,0,0,1.414-1.414L10.4141,35l1.2929-1.293A.9994.9994,0,0,0,11.707,32.293Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,42H7a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.707,32.293a.9994.9994,0,0,0-1.414,0L19,33.5859,17.707,32.293a1,1,0,0,0-1.414,1.414L17.5859,35,16.293,36.293a1,1,0,1,0,1.414,1.414L19,36.4141l1.293,1.2929a1,1,0,0,0,1.414-1.414L20.4141,35l1.2929-1.293A.9994.9994,0,0,0,21.707,32.293Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,42H17a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.707,32.293a.9994.9994,0,0,0-1.414,0L29,33.5859,27.707,32.293a1,1,0,0,0-1.414,1.414L27.5859,35,26.293,36.293a1,1,0,1,0,1.414,1.414L29,36.4141l1.293,1.2929a1,1,0,0,0,1.414-1.414L30.4141,35l1.2929-1.293A.9994.9994,0,0,0,31.707,32.293Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,42H27a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4141,35l1.2929-1.293a1,1,0,0,0-1.414-1.414L39,33.5859,37.707,32.293a1,1,0,0,0-1.414,1.414L37.5859,35,36.293,36.293a1,1,0,1,0,1.414,1.414L39,36.4141l1.293,1.2929a1,1,0,0,0,1.414-1.414Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,42H37a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z",
    fill: "#646464"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenError);
export default __webpack_public_path__ + "static/media/token-error.5c1ddad5b25c3c03e73e8dd70b4c9c62.svg";
export { ForwardRef as ReactComponent };